import { FormatPrice } from '@/components/blocks/HDMPriceDisplay/FormatPrice';
import { PDP_DISPLAY_PRICE_SIMPLE_TYPE } from '@/components/blocks/HDMPriceDisplay/constants';
import {
	catalogEntryListCompareDiscountBadgeSX,
	catalogEntryListCompareListPriceSX,
	catalogEntryListComparePriceRowSX,
} from '@/components/content/CatalogEntryList/styles/Compare/collectorPrice';
import { useLocalization } from '@/data/Localization';
import { ComparePriceProps } from '@/data/types/Compare';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';

type CatalogEntryListComparePriceProps = ComparePriceProps & {
	compact?: boolean;
};

export const CatalogEntryListComparePrice: FC<CatalogEntryListComparePriceProps> = ({
	product,
	compact,
}) => {
	const priceDisplayNLS = useLocalization('PriceDisplay');
	const hdmProductDetailNLS = useLocalization('HDMProductDetail');
	const currentPrice = product.productPrice?.offer ?? product.productPrice?.min;
	const originalPrice = product.productPrice?.list;
	const hasOriginalPrice =
		typeof originalPrice === 'number' &&
		typeof currentPrice === 'number' &&
		originalPrice > currentPrice;

	const discountPercentage = hasOriginalPrice
		? Math.trunc(((originalPrice - currentPrice) / originalPrice) * 100)
		: 0;

	return typeof currentPrice === 'number' ? (
		<Box>
			<Box sx={catalogEntryListComparePriceRowSX}>
				<FormatPrice price={currentPrice} variant={compact ? 'xs' : 'sm'} />
				{discountPercentage > 0 ? (
					<Box component="span" sx={catalogEntryListCompareDiscountBadgeSX}>
						{`-${discountPercentage}%`}
					</Box>
				) : null}
			</Box>
			{hasOriginalPrice ? (
				<Typography component="div" sx={catalogEntryListCompareListPriceSX}>
					{hdmProductDetailNLS.Before.t()}{' '}
					<FormatPrice type={PDP_DISPLAY_PRICE_SIMPLE_TYPE} price={originalPrice} />
				</Typography>
			) : null}
		</Box>
	) : (
		<>{priceDisplayNLS.Labels.Pending.t()}</>
	);
};
